/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Successmessage3Inputs */

const en_coinvestments_declinedeal_successmessage3 = /** @type {(inputs: Coinvestments_Declinedeal_Successmessage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have declined this opportunity. The GP has been notified.`)
};

/**
* | output |
* | --- |
* | "You have declined this opportunity. The GP has been notified." |
*
* @param {Coinvestments_Declinedeal_Successmessage3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_successmessage3 = /** @type {((inputs?: Coinvestments_Declinedeal_Successmessage3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Successmessage3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_successmessage3(inputs)
});
export { coinvestments_declinedeal_successmessage3 as "coInvestments_declineDeal_successMessage" }